const topics = [
  {
    title: "Magnetism",
    slug: "magnetism",
    standardNumber: "2.2",
    description: "Force, Motion, and Energy – The student will investigate and understand that different types of forces may cause an object’s motion to change.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmagnetism.mp4?alt=media&token=8c8960a9-9c0c-4999-afab-33fc8236272c",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmagnetism.mp3?alt=media&token=b29a916b-8eb4-4db7-b351-9474d95aa167",
    lyrics: ["(chorus)",
"Like charges repel, push away",
"opposite charges attract, come together",
"Certain metals are magnetic, are magnetic",
"Certain metals are magnetic, are magnetic",

"(verse)",
"Magnetic poles, the strongest point of a magnet",
"North and south, north and south",
"Magnetic field is the force from the poles of a magnet",
"Magnetic field, magnetic field",
"Electromagnet is made by wrapping a wire around certain metals,",
"around certain metals",
"Electromagnet is not a permanent magnet,",
"not a permanent magnet",

"(chorus)",
"Like charges repel, push away",
"opposite charges attract, come together",
"Certain metals are magnetic, are magnetic",
"Certain metals are magnetic, are magnetic",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Force",
    slug: "force",
    standardNumber: "2.2",
    description: "Force, Motion, and Energy – The student will investigate and understand that different types of forces may cause an object’s motion to change.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fforce.mp4?alt=media&token=d90d58e8-21a5-403e-9cb9-4d065fb9c655",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fforce2025song.mp3?alt=media&token=aeed54c4-234a-4568-800a-a2b8ab0c9b11",
    lyrics: ["(Chorus)",
"If you give a push or give a pull,",
"that is force to an object.",
"If you give a push or give a pull,",
"that is force to an object.",

"(Verse)",
"Force is a push or a pull that will",
"make an object stop.",
"Force is a push or a pull that will",
"change an object's speed.",
"Force is a push or a pull that will",
"change an object's direction.",
"Force is a push or a pull that will",
"change an object's direction.",

"(Chorus)",
"If you give a push or give a pull,",
"that is force to an object.",
"If you give a push or give a pull,",
"that is force to an object.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "dragDrop",
    titleImage: "",
  },
  {
    title: "Gravity",
    slug: "gravity",
    standardNumber: "2.2",
    description: "Force, Motion, and Energy – The student will investigate and understand that different types of forces may cause an object’s motion to change.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fgravityvideo.mp4?alt=media&token=63493362-6c8b-4590-ac8f-49b9b794b17a",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fgravity2025song.mp3?alt=media&token=48857943-5ba4-441d-b04b-0802504ceae4",
    lyrics: ["(chorus)",
"Earth is one of eight planets that go around the sun.",
"Asteroids, comets, and dust particles all go around the sun.",
"Earth is one of eight planets that go around the sun.",
"Asteroids, comets, and dust particles all go around the sun,",
"because gravity, gravity, gravity, gravity, gravity,",
"because",

"(verse 1)",
"Everything is made up of matter.",
"The amount of matter is called mass.",
"Now some objects have great mass than others.",
"Some objects have little.",
"In space objects with greater mass",
"pull other objects together, together.",

"(chorus)",
"Earth is one of eight planets that go around the sun.",
"Asteroids, comets, and dust particles all go around the sun.",
"Earth is one of eight planets that go around the sun.",
"Asteroids, comets, and dust particles all go around the sun,",
"because gravity, gravity, gravity, gravity, gravity,",
"because",

"(verse 2)",
"Without gravity everything on earth",
"will go floating in the air.",
"Gravity pulling us towards earth’s center",
"keeps us here, keeps us here.",
"So, when you jump up, you go back down.",
"Throw a ball up and it comes right down.",
"That’s gravity, gravity, gravity, gravity, gravity,",
"because",

"(chorus)",
"Earth is one of eight planets that go around the sun.",
"Asteroids, comets, and dust particles all go around the sun.",
"Earth is one of eight planets that go around the sun.",
"Asteroids, comets, and dust particles all go around the sun,",
"because gravity, gravity, gravity, gravity, gravity,",
"because…",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Matter",
    slug: "matter",
    standardNumber: "2.3",
    description: "Matter – The student will investigate and understand that matter can exist in different phases.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmatterrock2025video.mp4?alt=media&token=9dcb63a2-cfea-49ca-8cc7-0d30700ecab3",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmatterrock2025song.mp3?alt=media&token=78f1e7a9-8c65-4b5a-8489-430d502eb06c",
    lyrics: ["(Chorus)",
"Matter has mass and takes up space.",
"Matter has mass and takes up space.",
"Three states of matter,",
"Solid, liquid, and gas.",
"Three states of matter,",
"Solid, liquid, and gas.",

"(Verse)",
"Solids, they keep their shape.",
"Solids, they keep their shape.",
"Particles are packed tightly in solids, vibrating.",
"Particles are packed tightly in solids, vibrating.",

"Liquids take the shape of its container.",
"Liquids take the shape of its container.",
"Particles are spread out a little, sliding past each other.",
"Particles are spread out a little, sliding past each other.",

"In gases, the shape will change with its container.",
"In gases, the volume will change with its container.",
"Particles are spread out and move very quickly.",
"Particles are spread out and move very quickly.",

"(Chorus)",
"Matter has mass and takes up space.",
"Matter has mass and takes up space.",
"Three states of matter,",
"Solid, liquid, and gas.",
"Three states of matter,",
"Solid, liquid, and gas.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "dragDrop",
    titleImage: "",
  },
  {
    title: "3 States of Matter",
    slug: "3statesofmatter",
    standardNumber: "2.3",
    description: "Matter – The student will investigate and understand that matter can exist in different phases.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F3statesofmatter2025video.mp4?alt=media&token=a521644b-b4eb-4a56-89e2-2beb95c71ad7",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F3statesofmatter2025song.mp3?alt=media&token=4ca634b8-d275-41d6-9e49-36d59970db1b",
    lyrics: ["(Chorus)",
"Matter is everything around you.",
"Matter is made of atoms and molecules.",
"3 states: solids, liquids, gases.",
"3 states: solids, liquids, gases.",

"(Verse)",
"Solids, yes, are hard.",
"Liquids are more like water.",
"Gases are like the atmosphere,",
"That surrounds the earth, our air.",
"Solids, yes, are hard.",
"Liquids are more like water.",
"Gases are like the atmosphere,",
"That surrounds the earth, our air.",
"Those are the 3 states of matter,",
"Those are the 3 states of matter.",
"Solids, liquids, gases.",
"Solids, liquids, gases.",

"(Chorus)",
"Matter is everything around you.",
"Matter is made of atoms and molecules.",
"3 states: solids, liquids, gases.",
"3 states: solids, liquids, gases.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "dragDrop",
    titleImage: "",
  },
  {
    title: "Animal Life Cycle",
    slug: "animallifecycle",
    standardNumber: "2.4",
    description: "Living Systems and Processes – The student will investigate and understand that plants and animals undergo a series of orderly changes as they grow and develop.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fanimallifecycle2025video.mp4?alt=media&token=a5f4b0b0-5ca0-436f-8d09-0b25bc2cc186",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fanimallifecycle2025song%20.mp3?alt=media&token=666e6c14-f00a-4379-95cc-3047adb2ac18",
    lyrics: ["(Chorus)",
"Born, developing, reproducing.",
"Life cycle of animals.",
"Born, developing, reproducing.",
"Life cycle of animals.",

"(Verse)",
"Now, all animal life cycles are the same in some ways.",
"We’re all born, we develop, we reproduce, then the cycle starts over again.",
"Humans start reproducing from an egg inside a mother's body,",
"For 9 months then they’re born, learning for 3 years as babies.",
"Then we grow into children, taller, smarter, more independent.",
"Around the ages 13 to 18, we’re teenagers, adolescents.",
"After that, we become adults until we are old and grey.",
"Start a family, when we reproduce the life cycle starts over again.",

"(Chorus)",
"Born, developing, reproducing.",
"Life cycle of animals.",
"Born, developing, reproducing.",
"Life cycle of animals.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "dragDrop",
    titleImage: "",
  },
  {
    title: "Plant Life Cycle",
    slug: "plantlifecycle",
    standardNumber: "2.4",
    description: "Living Systems and Processes – The student will investigate and understand that plants and animals undergo a series of orderly changes as they grow and develop.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fplantlifecycle.mp4?alt=media&token=04c5304e-ef30-4fec-b739-882b2fd418ab",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplantlifecycle.mp3?alt=media&token=20abb63d-b1eb-4ab8-b653-4bd0e6bffc81",
    lyrics: ["(chorus)",
"Plant life cycle, oh-wo-wo- oh -wo-wo.,",
"Plant life cycle, oh-wo-wo- oh -wo-wo.,",
"Plant life cycle, oh-wo-wo- oh -wo-wo.,",
"Plant life cycle, oh-wo-wo- oh -wo-wo.,",

"(verse)",
"Now, all plant seeds have an outer cover called a seed coat,",
"to protect the plant inside the seed called the embryo.,",
"When the seed germinates, the root bust out then start growing down.,",
"Then the seed germinates, the shoot bust out, grows up above the ground.,",
"Now it’s a sprout right there.,",
"With help from the water, soil, sun, and air,",
"the plant becomes a seedling.,",
"A small plant with a few leaves.,",
"The next stage is a young adult plant.,",
"Over time it becomes a full adult plant.,",
"Then you’ll see the flowers or spores,",
"used to reproduce and make more,,",
"and make more,,",
"through pollination.,",

"(chorus)",
"Plant life cycle, oh-wo-wo- oh -wo-wo.,",
"Plant life cycle, oh-wo-wo- oh -wo-wo.,",
"Plant life cycle, oh-wo-wo- oh -wo-wo.,",
"Plant life cycle, oh-wo-wo- oh -wo-wo.,",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Metamorphosis",
    slug: "metamorphosis",
    standardNumber: "2.4",
    description: "Living Systems and Processes – The student will investigate and understand that plants and animals undergo a series of orderly changes as they grow and develop.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmetamorphosis2025video.mp4?alt=media&token=089e2f87-60f3-45f8-a0bc-c404fa20a32d",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmetamorphosis2025song.mp3?alt=media&token=66998bf3-9960-4e1d-b273-f8b3dce186a6",
    lyrics: ["(chorus)",
"Metamorphosis is the process",
"An animal takes when it changes shapes.",
"Metamorphosis is the process",
"An animal takes when it changes shapes.",

"(verse)",
"Let’s look at a frog when it’s born,",
"The eggs hatch and the tadpole comes on.",
"The tadpoles live in the pond",
"With a tail, no legs, no arms.",
"Then after a while the legs start to form.",
"The tail starts to shrink till it’s all gone.",
"The eyes bulge out, the lungs finish developing.",
"Now living on land, the frog is here.",

"(chorus)",
"Metamorphosis is the process",
"An animal takes when it changes shapes.",
"Metamorphosis is the process",
"An animal takes when it changes shapes.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Ladybug",
    slug: "ladybug",
    standardNumber: "2.4",
    description: "Living Systems and Processes – The student will investigate and understand that plants and animals undergo a series of orderly changes as they grow and develop.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fladybug2025video.mp4?alt=media&token=c2b6994f-5378-43ca-b54f-e0d4ffecb949",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fladybug2025song.mp3?alt=media&token=1e2134f5-8637-4675-a7fb-fae4f196b6fc",
    lyrics: ["(chorus)",
"Ladybug, ladybug, crawling all around,",
"Changing and growing without a sound,",
"Egg to larva, pupa too,",
"Then out comes a bug that’s red and new!,",
"Ladybug, ladybug, fly so high,",
"Spots on your back and wings in the sky!,",

"(verse)",
"What is this I see?,",
"I see the ladybug’s eggs, yellow and small.,",
"What is this I see?,",
"I see the eggs hatch and the larva starts to crawl.,",
"What is this I see?,",
"I see the larva eat and I see the larva grow.,",
"What is this I see?,",
"The larva finds a leaf for now and that will be its home.,",
"What is this I see?,",
"The larva becomes a pupa. That’s something like a shell.,",
"What is this I see?,",
"A ladybug comes out of the pupa, doing well!,",

"(chorus)",
"Ladybug, ladybug, crawling all around,",
"Changing and growing without a sound,",
"Egg to larva, pupa too,",
"Then out comes a bug that’s red and new!,",
"Ladybug, ladybug, fly so high,",
"Spots on your back and wings in the sky!,",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Animal Needs",
    slug: "animalneeds",
    standardNumber: "2.5",
    description: "Living Systems and Processes – The student will investigate and understand that living things are part of a system.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fanimalneeds2025video.mp4?alt=media&token=978e27e2-505d-4ad0-a2ca-3adecda5d8a1",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fanimalneeds2025song.mp3?alt=media&token=53c6f12a-b401-47a5-b189-e4bcc774dc86",
    lyrics: ["(Chorus)",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",

"(Verse 1)",
"Basic needs of animals, no need to wonder,",
"For animals to survive, they need food, shelter, and water.",
"Basic needs of animals, no need to wonder,",
"For animals to survive, they need food, shelter, and water.",

"(Chorus)",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",

"(Verse 2)",
"Some animals need sunlight, like plants on the ground.",
"Others need oxygen, to keep them safe and sound.",
"Every living creature, big or small, it’s true,",
"Depends on their environment, just like me and you.",

"(Chorus)",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "dragDrop",
    titleImage: "",
  },
  {
    title: "Habitats",
    slug: "habitats",
    standardNumber: "2.5",
    description: "Living Systems and Processes – The student will investigate and understand that living things are part of a system.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fhabitats2025video.mp4?alt=media&token=9d996902-5aa1-4927-bb6d-4ac291b420b2",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fhabitats2025song.mp3?alt=media&token=ac676b90-d3da-45be-8dcb-f0ad121b1ba0",
    lyrics: ["(Chorus)",
"Habitats are places with populations.",
"Habitats are where plants or animals live.",
"Habitats are places with populations.",
"Habitats are where plants or animals live.",

"(Verse)",
"In a habitat, you will find,",
"A group of organisms of the same kind,",
"Living together at the same time,",
"Living together.",
"Now that habitat supplies food,",
"Water, temperature just right,",
"Minerals—that’s right,",
"What organisms need to survive.",
"Ants have their own habitat (ant farms).",
"Bees have their own habitat (beehives).",
"Fish have their own habitats (water).",
"Toucans have a habitat (the rainforest).",

"(Chorus)",
"Habitats are places with populations.",
"Habitats are where plants or animals live.",
"Habitats are places with populations.",
"Habitats are where plants or animals live.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Ecosystems All Around",
    slug: "ecosystemssallaround",
    standardNumber: "2.5",
    description: "Living Systems and Processes – The student will investigate and understand that living things are part of a system.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fecosystemsallaround2025video.mp4?alt=media&token=906c039b-fa1f-445f-966c-bf78cfa3d2a3",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fecosystemsallaround2025song.mp3?alt=media&token=a82bc582-d017-4571-8774-bb25bfb95717",
    lyrics: ["(chorus)",
"Ecosystems all around, let’s explore.",
"From forests to oceans, there’s so much more!",
"Biotic and abiotic, working together,",
"supporting life through every weather!",

"(verse 1)",
"In the grasslands, the grass sway,",
"Bison and birds roam all day.",
"Small shrubs, insects, and prairie dogs too,",
"They all need shelter, water, and food!",
"In the ocean, fish swim with ease,",
"Seaweed sways in the salty breeze.",
"Ponds and lakes are home to frogs,",
"With lily pads and swimming logs.",

"(chorus)",
"Ecosystems all around, let’s explore.",
"From forests to oceans, there’s so much more!",
"Biotic and abiotic, working together,",
"supporting life through every weather!",

"(verse 2)",
"Forests are filled with towering trees,",
"Beetles and owls in the leafy seas.",
"Rivers and streams flow fast and free,",
"Supporting fish and life, endlessly.",
"Every ecosystem helps life succeed.",
"From land to water, let’s take a look,",
"Ecosystems are nature’s storybook!",

"(chorus)",
"Ecosystems all around, let’s explore.",
"From forests to oceans, there’s so much more!",
"Biotic and abiotic, working together,",
"supporting life through every weather!",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Determine Weather",
    slug: "determineweather",
    standardNumber: "2.6",
    description: "Earth and Space Systems – The student will investigate and understand that there are different types of weather on Earth.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fdetermineweather2025video.mp4?alt=media&token=b0dc68f0-f495-4f84-81eb-e9b804dda225",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdetermineweather2025song.mp3?alt=media&token=24b9d787-ecf5-4951-9b5e-3f9be7efc183",
    lyrics: ["(Verse)",
"To determine the weather in a particular time and place,",
"You should know the temperature, that’s the measure",
"Of the degree of heat of a substance.",

"To determine the weather in a particular time and place,",
"Look for precipitation, rain, sleet, snow, hail,",
"And time period amounts.",

"To determine the weather in a particular time and place,",
"You should know the wind direction,",
"Which way is it blowing? North, South, East, or West.",

"To determine the weather in a particular time and place,",
"You should know the wind speed, the rate of motion of the air",
"In knots or nautical miles.",

"To determine the weather in a particular time and place,",
"You should know a barometer is used to measure",
"The atmospheric pressure.",

"To determine the weather in a particular time and place,",
"You should know that humidity",
"Is the amount of water vapor in the air, yeah, yeah, yeah, yeah.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "dragDrop",
    titleImage: "",
  },
  {
    title: "Environmental Change",
    slug: "environmentalchange",
    standardNumber: "2.7",
    description: "Earth and Space Systems – The student will investigate and understand that weather patterns and seasonal changes affect plants, animals, and their surroundings.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fenvironmentalchange2025video.mp4?alt=media&token=ebe3afdd-fb4b-4722-8ae2-f2c469edc617",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fenvironmentalchange2025song.mp3?alt=media&token=7fb064e4-0513-4dea-b929-47ff30f1e3e0",
    lyrics: ["(Chorus)",
"Organisms can thrive in changing environments,",
"If they adapt or move away, they still might stand a chance.",
"Organisms can thrive in changing environments,",
"But some may fail to live if they can't meet new demands.",

"(Verse 1)",
"Some organisms adapt to their surroundings' shift,",
"They change their behaviors or grow a special gift.",
"Adaptation.",
"But if the change is sudden and the shift is too extreme,",
"Some might not survive or fulfill their living dreams.",
"Extinction.",
"Some migrate to new spaces where conditions suit them more,",
"While others stay and perish where they were before.",
"Adaptation.",

"(Bridge)",
"If the food supply disappears or the water runs dry,",
"Life can become a struggle, and many might die.",
"But some species are resilient and can find a new way,",
"To make a home in places where others couldn’t stay.",

"(Chorus)",
"Organisms can thrive in changing environments,",
"If they adapt or move away, they still might stand a chance.",
"Organisms can thrive in changing environments,",
"But some may fail to live if they can't meet new demands.",

"(Verse 2)",
"When climates shift to heat waves or freezing snow and ice,",
"Some species can evolve, but others pay the price.",
"Natural Selection.",
"If pollution fills their waters or habitats are gone,",
"It creates new challenges to simply carry on.",
"Survival.",
"Genetics play a role in how species cope with change,",
"Some will grow stronger while others fade away.",
"Natural Selection.",

"(Outro)",
"Organisms rise or fall depending on their fate,",
"How they respond to changes can truly resonate.",
"Adapting or migrating, or even disappearing,",
"The story of survival is both harsh and endearing.",

"(Chorus)",
"Organisms can thrive in changing environments,",
"If they adapt or move away, they still might stand a chance.",
"Organisms can thrive in changing environments,",
"But some may fail to live if they can't meet new demands.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Surface Change",
    slug: "surfacechange",
    standardNumber: "2.7",
    description: "Earth and Space Systems – The student will investigate and understand that weather patterns and seasonal changes affect plants, animals, and their surroundings.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsurfacechange2025video.mp4?alt=media&token=ac73c746-d5ee-470f-9d84-f04f7a4c0eb8",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsurfacechange2025song.mp3?alt=media&token=6649da82-6912-4a1a-8016-9a869576e845",
    lyrics: ["(chorus)",
"Now I see a change, you see a change, I see a change, on the surface.",
"They see a change, we see a change, they see a change, on the surface.",

"(verse1)",
"Now, what can affect the changes of the earth’s surface?",
"Let’s see, that’s erosion, erosion.",
"When rocks and soil are broken down and wear down the surface,",
"That’s erosion, erosion.",
"Weathering happens when rocks break apart",
"Due to the weather, mechanical and chemical.",
"Weathering happens when rocks break apart",
"Due to the weather, mechanical and chemical.",
"Mechanical weathering happens when rocks break apart",
"Because of flowing water or ice.",
"Mechanical weathering happens when rocks break apart",
"Because it’s too cold or too hot.",
"In chemical weathering, water dissolves the minerals",
"In the rock and the rock breaks apart.",
"In chemical weathering, water dissolves the minerals",
"In the rock and the rock breaks apart.",

"(chorus)",
"Now I see a change, you see a change, I see a change, on the surface.",
"They see a change, we see a change, they see a change, on the surface.",
"Now I see a change, you see a change, I see a change, on the surface.",
"They see a change, we see a change, they see a change, on the surface.",

"(verse2)",
"A canyon is a valley between cliffs.",
"There’s often a river flowing through it.",
"The river eroded the layers of rocks",
"And weather caused erosion to occur.",
"Mountains sit high, they’re naturally made",
"When the earth’s crust folds into great waves.",
"From lava, a volcanic mountain is made",
"And erosion gives mountains their shape.",
"It can be an earthquake that changes the shape",
"Of the earth’s surface that starts to shake.",
"It can be a volcano that’s opened up",
"From which lava, gases, and rock erupt.",

"(chorus)",
"Now I see a change, you see a change, I see a change, on the surface.",
"They see a change, we see a change, they see a change, on the surface.",
"Now I see a change, you see a change, I see a change, on the surface.",
"They see a change, we see a change, they see a change, on the surface.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Weathering",
    slug: "weathering",
    standardNumber: "2.7",
    description: "Earth and Space Systems – The student will investigate and understand that weather patterns and seasonal changes affect plants, animals, and their surroundings.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fweathering2025video.mp4?alt=media&token=a9649c8d-b5b6-4180-b9f9-4b1746923164",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fweathering2025song.mp3?alt=media&token=d7242a48-cd46-42b9-8136-1dbab7e492c4",
    lyrics: ["(Chorus)",
"Breaking down Earth’s surface.",
"Breaking down Earth’s surface.",
"By weathering,",
"By erosion.",
"Breaking down Earth’s surface.",
"Breaking down Earth’s surface.",
"By weathering,",
"By erosion.",

"(Verse)",
"Weathering is when the rain and wind,",
"Wears away the Earth’s surface.",

"Erosion is when rocks and soil are broken down,",
"And wears down the Earth’s surface.",

"Deposition is when those broken-down rocks and minerals,",
"Are transported to another place.",

"(Chorus)",
"Breaking down Earth’s surface.",
"Breaking down Earth’s surface.",
"By weathering,",
"By erosion.",
"Breaking down Earth’s surface.",
"Breaking down Earth’s surface.",
"By weathering,",
"By erosion.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
];
export default topics;


